import { Feature, FeatureConfig } from '../../shared/structs';

const featureToggleDefaults: Record<Feature, FeatureConfig> = {
  isMarketingOnly: { activated: false },
};

export default featureToggleDefaults;
